/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import {
  Box,
  Button,
  Drawer,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import FormTitle from "../../../form-fields/form-title";
import TextInput from "../../../form-fields/text-input";
import SelectInput from "../../../form-fields/select-input";
import DashBoardContainer from "../../../layout/dashboard-container";
import { FormLabel, FormValue, GridRow } from "./custom-form-grid";
import { useSelector } from "react-redux";
import { useFormik, FormikProvider, Form } from "formik";
import { useNavigate } from "react-router-dom";
import FormButtons from "../buttons";
import useApiState from "../../common/useApiState";
import Loader from "../../../loader/loader";
import AlertMsg from "../../../common/alert";
import { CheckCircle, RadioButtonChecked } from "@mui/icons-material";

const SearchPropertyToGenReceipt = () => {
  const navigate = useNavigate();
  const initialState = {
    propertyNumber: "",
  };
  const { loading, setLoading, error, setError, success, setSuccess } =
    useApiState();
  const [selectedIndex, setSelectedIndex] = useState(4); // State for active item
  const lang = useSelector((state) => state.userDetails.lang);
  const formik = useFormik({
    initialValues: initialState,
    // validationSchema: ,
  });

  const handleSubmitButtonClick = async (e) => {
    e.preventDefault();
    navigate("/home");
  };

  const handleListItemClick = (index) => {
    setSelectedIndex(index); // Set the clicked item as the active one
  };

  const menuItems = [
    "Quick Pay",
    "UPIC No.",
    "Mobile No.",
    "Tax Payer Name",
    "Property No.",
  ];

  return (
    <DashBoardContainer>
      {loading && <Loader />}
      {error && (
        <AlertMsg
          severity="error"
          onClose={() => {
            setError("");
          }}
        />
      )}
      <FormikProvider value={formik}>
        <Form>
          <Grid display="flex" justifyContent="center">
            {/* <Paper elevation={4} sx={{ marginBottom: "15px", width: 800 }}> */}
            {/* <FormTitle title="Search Property" /> */}
            {/* <Box> */}

            <Paper
              elevation={3}
              sx={{
                width: 800,
                // height: "100%",
                marginLeft: 2,
                padding: 2,
                display: "flex",
                flexDirection: "column",
                bgcolor: "#ffffff", // Background color for the entire menu
              }}
            >
              <FormTitle title="Search Property" />
              <Grid container spacing={2} mt={3}>
                <Grid md={4} xs={12}>
                  <List>
                    {menuItems.map((text, index) => (
                      <ListItem
                        Button
                        key={text}
                        selected={selectedIndex === index} // Highlight selected item
                        onClick={() => handleListItemClick(index)}
                        sx={{
                          height: "35px",
                          width: "100%",
                          cursor: "pointer",
                          bgcolor:
                            selectedIndex === index ? "#d3d3d3" : "#3696f5", // Active item background color
                          marginBottom: 1,
                          borderRadius: 2,
                          boxShadow:
                            selectedIndex === index
                              ? "0px 4px 6px rgba(38 149 24)"
                              : "none", // Add shadow to list item
                          "&:hover": {
                            bgcolor: "#d3d3d3", // Background color on hover
                          },
                        }}
                      >
                        <ListItemIcon>
                          {selectedIndex === index ? (
                            <CheckCircle color="success" /> // Show active icon
                          ) : (
                            <RadioButtonChecked /> // Show inactive icon
                          )}
                        </ListItemIcon>
                        <ListItemText primary={text} />
                      </ListItem>
                    ))}
                  </List>
                </Grid>
                <Grid md={8} xs={12}>
                  <Grid mt={10} ml={10} display="flex" justifyContent="center">
                    <Grid>
                      {menuItems[selectedIndex]}
                    </Grid>
                    <Grid ml={5}>
                      <TextInput name="searchPropertyBy" required />
                    </Grid>
                    {/* <FormLabel label={menuItems[selectedIndex]} />
                    <FormValue
                      component={<TextInput name="searchPropertyBy" required />}
                    /> */}
                  </Grid>
                  <Grid
                    mt={5}
                    pl={15}
                    pr={10}
                    display="flex"
                    justifyContent="center"
                  >
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleSubmitButtonClick}
                      sx={{ marginRight: "20px" }}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      color="warning"
                      onClick={() => {
                        navigate("/home");
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Form>
      </FormikProvider>
    </DashBoardContainer>
  );
};
export default SearchPropertyToGenReceipt;
